import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, onSnapshot, doc, deleteDoc } from "firebase/firestore";

const AdminCategoryList = ({ onEdit, onViewProducts }) => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "categorias"), (snapshot) => {
      setCategories(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubProducts = onSnapshot(collection(db, "productos"), (snapshot) => {
      setProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubProducts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("¿Seguro de eliminar esta categoría?")) {
      await deleteDoc(doc(db, "categorias", id));
    }
  };

  if (categories.length === 0) {
    return <div className="text-gray-400 italic">No hay categorías agregadas aún.</div>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {categories.map((cat) => {
        // Contar productos con category igual al nombre de la categoría
        const count = products.filter(
          (prod) => prod.category === cat.name
        ).length;
        return (
          <div key={cat.id} className="bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center border hover:shadow-2xl transition">
            <img
              src={cat.image}
              alt={cat.name}
              className="w-24 h-24 object-cover rounded-lg border mb-3"
            />
            <h3 className="text-lg font-bold text-primary mb-2">{cat.name}</h3>
            <div className="text-sm text-gray-500 mb-2">
              {count === 1 ? "1 producto" : `${count} productos`}
            </div>
            <div className="flex gap-3 mt-2">
              <button
                className="bg-yellow-400 text-white font-bold px-4 py-2 rounded-lg hover:bg-yellow-500"
                onClick={() => onEdit(cat)}
              >
                Editar
              </button>
              <button
                className="bg-red-500 text-white font-bold px-4 py-2 rounded-lg hover:bg-red-700"
                onClick={() => handleDelete(cat.id)}
              >
                Eliminar
              </button>
              {onViewProducts && (
                <button
                  className="bg-blue-600 text-white font-bold px-4 py-2 rounded-lg hover:bg-blue-700"
                  onClick={() => onViewProducts(cat.name)}
                >
                  Ver productos
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AdminCategoryList;
